import { createRouter, createWebHistory } from 'vue-router';

// account-ui is the global, tenant-independent host for the data-subject
// surfaces (#241 D27; the records behind them are ADR 0051's). Its route table
// is an EXPLICIT ALLOWLIST — no
// catch-all into module territory — so anything not named here lands back on
// the account home instead of resolving to a blank view.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'account-home',
      component: () => import('@/views/AccountHomeView.vue'),
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

export default router;
